const AppStoreIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.086 15.9192C24.0523 12.2673 27.1529 10.4906 27.2946 10.4079C25.5387 7.91179 22.817 7.57074 21.8606 7.54355C19.5747 7.309 17.3574 8.87717 16.1929 8.87717C15.0053 8.87717 13.2121 7.56621 11.2795 7.60473C8.79257 7.64213 6.46601 9.04599 5.19 11.226C2.55664 15.671 4.52062 22.2031 7.04358 25.7961C8.30564 27.5557 9.78037 29.5205 11.7106 29.4514C13.5991 29.3754 14.3045 28.2775 16.5834 28.2775C18.8414 28.2775 19.5038 29.4514 21.4724 29.4072C23.4992 29.3754 24.7752 27.6396 25.9931 25.8641C27.4515 23.8472 28.0372 21.861 28.0605 21.759C28.0128 21.7431 24.1244 20.2962 24.086 15.9192Z"
        fill="black"
      />
      <path
        d="M20.3673 5.17998C21.383 3.94154 22.0779 2.25667 21.885 0.546875C20.4149 0.610327 18.5764 1.53831 17.5177 2.74955C16.5811 3.8169 15.7444 5.56635 15.9605 7.21156C17.6119 7.33167 19.3074 6.39915 20.3673 5.17998Z"
        fill="black"
      />
    </svg>
  )
}

export default AppStoreIcon
